import { useTranslation } from 'react-i18next';
import React from 'react';
import cx from 'clsx';

import { IconActionChain } from '@/assets/stream';
import { Modal } from '@/components';
import { useSwitch } from '@/hooks';
import { CHAINS_DICT } from '@/utils';

import { LinkParsedContentMono } from '../../Content';
import { useChainNonce } from '../hook';
import { ActionWrapper, ActionProps } from './Wrapper';
import style from './index.module.scss';

export const ChainUser = (props: ActionProps) => {
  const { t } = useTranslation();

  const { data: action } = props;

  const { on, turnOn, turnOff } = useSwitch();

  return (
    <>
      <ActionWrapper
        {...props}
        onActionClick={turnOn}
        avatar={<img src={IconActionChain} className={style.actionIcon} alt="action" />}>
        [{action.data.chain_id ? CHAINS_DICT[action.data.chain_id]?.name : ''}]{' '}
        {t('Actions_ChainUser.18kczbi')}
      </ActionWrapper>
      {on ? <ConfirmModal action={action} turnOff={turnOff} /> : null}
    </>
  );
};

const { CommonModal } = Modal;

const ConfirmModal = ({
  action,
  turnOff,
}: {
  turnOff: () => void;
  action: ActionProps['data'];
}) => {
  const { t } = useTranslation();

  // 返回的 nonce
  const { data: isUsed, isLoading } = useChainNonce(action.data.chain_id!);

  return (
    <CommonModal turnOff={turnOff} containerClassName={style.confirmModal}>
      <div className={style.cmTitle}>
        <img src={IconActionChain} className={style.actionIcon} alt="action" />
        {t('Actions_ChainUser.1wn7jm2')}
      </div>
      <div className={style.cmField}>
        <div className={style.cmfTitle}>{t('Actions_ChainUser.12qowx')}</div>
        <div className={style.protocolName}>
          <img
            src={CHAINS_DICT[action.data.chain_id!].logo || IconActionChain}
            className={style.actionIcon}
            alt="action"
          />
          {CHAINS_DICT[action.data.chain_id!]?.name}
        </div>
      </div>
      <div className={style.cmFieldRow}>
        <span className={style.cmfTitle}>{t('Actions_ChainUser.154b66q')}</span>
        <span className={cx(style.cmfValue, isUsed && style.isUsed)}>
          {isLoading ? '-' : isUsed ? t('Actions_ChainUser.used') : t('Actions_ChainUser.unused')}
        </span>
      </div>
      <div className={style.cmField}>
        <div className={style.cmfTitle}>{t('Actions_ChainUser.description')}</div>
        <div className={style.cmfBgValue}>
          <LinkParsedContentMono content={action.data.desc} linkClassnames={style.cmLinkParsed} />
        </div>
      </div>
    </CommonModal>
  );
};
